import React from "react";
import { LOCALE_STRINGS } from "constants/locales";

const TruckIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 3H15V16H1V3ZM15 8H19L22 11V16H15V8ZM5.5 19C4.67 19 4 18.33 4 17.5C4 16.67 4.67 16 5.5 16C6.33 16 7 16.67 7 17.5C7 18.33 6.33 19 5.5 19ZM17.5 19C16.67 19 16 18.33 16 17.5C16 16.67 16.67 16 17.5 16C18.33 16 19 16.67 19 17.5C19 18.33 18.33 19 17.5 19Z"
      stroke="#008CB7"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const CheckSquareIcon = () => (
  <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 11L12 14L22 4M21 12V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16"
      stroke="#008CB7"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FinancingSection = ({ language = "EN" }) => {
  const langKey = language?.toUpperCase?.() || "EN";
  const strings = LOCALE_STRINGS?.[langKey] || LOCALE_STRINGS?.[language] || {};

  return (
    <section className="financing-section-wrapper">
      <div className="financing-content-block">
        
        <div className="financing-header-container">
          <h2 className="financing-heading">
            {strings.financing_title || "Financing on both sides of the shipment"}
          </h2>
          <p className="financing-supporting-text">
            {strings.financing_subtitle ||
              "Whichever side of the trade you're on, capital shouldn't wait on the goods to move first"}
          </p>
        </div>

        <div className="financing-cards-container">
          
          <div className="finance-card">
            <div className="finance-icon-container">
              <TruckIcon />
            </div>
            <div className="finance-card-content">
              <h3 className="finance-card__title">
                {strings.financing_card1_title || "Pre-Shipment Financing"}
              </h3>
              <p className="finance-card__description">
                {strings.financing_card1_desc ||
                  "A revolving trade credit line for importers and exporters, so purchase and production costs get funded before goods ever leave the factory floor."}
              </p>
            </div>
          </div>

          <div className="finance-card">
            <div className="finance-icon-container">
              <CheckSquareIcon />
            </div>
            <div className="finance-card-content">
              <h3 className="finance-card__title">
                {strings.financing_card2_title || "Post-Shipment Financing"}
              </h3>
              <p className="finance-card__description">
                {strings.financing_card2_desc ||
                  "Invoice factoring and receivables financing that give exporters immediate liquidity against outstanding invoices — no waiting on a buyer's payment terms."}
              </p>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};